import {useTranslation} from 'react-i18next';

import {Grid, Typography} from '@mui/material';

import {greenColors} from '../../../../layouts/theme/designSystem';

export const LimitReachedMessage = () => {
  const {t} = useTranslation('translation', {keyPrefix: 'screeningModule'});
  return (
    <Grid
      item
      xs={12}
      sx={{
        backgroundColor: greenColors[4],
        borderRadius: '8px',
        marginBottom: '12px',
      }}
    >
      <Typography variant='body2' sx={{padding: '8px', color: greenColors[900]}} textAlign={'center'} fontWeight={600}>
        {/* TODO: Check with @Julio or @Larrisa for the content of the message */}
        {t('limitReached')}
      </Typography>
    </Grid>
  );
};
